export default function (t) {
  return [
    { title: t('general.name'), field: 'signatory.name' },
    { title: t('general.position'), field: 'position' },
  ];
}
